const defaultPrivacyPolicyUrl = 'https://licitar.digital/politica-de-privacidade/index.html';
const defaultTermsOfServiceUrl =
    'https://licitar.digital/regulamento-sistema-de-compras-digital-licitar-digital/index.html';

export { defaultPrivacyPolicyUrl, defaultTermsOfServiceUrl };
